export interface ProviderDashboardTileSettingDto {
  ZIndex: number;
  DisplayOrder: number;
  ColumnNumber: number;
}

// can't use the reverse mapping of this numeric enum on MessagesProviderDashboardTileSettingDto
// and other adjacent classes because of a typing issue:
// https://github.com/microsoft/TypeScript/issues/38806
// So I just converted this to a string enum instead.
export enum ProviderDashboardTileTypes {
  Calendar= 'Calendar',
  Messages = 'Messages',
  Notes = 'Notes',
  ExternalPatients = 'ExternalPatients',
  ChargeCapture = 'ChargeCapture',
}
